import { render } from "./gmdetail.vue?vue&type=template&id=5562272a&scoped=true"
import script from "./gmdetail.vue?vue&type=script&lang=js"
export * from "./gmdetail.vue?vue&type=script&lang=js"

import "./gmdetail.vue?vue&type=style&index=0&id=5562272a&lang=scss&scoped=true"
import "./gmdetail.vue?vue&type=style&index=1&id=5562272a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5562272a"]])

export default __exports__